/* ============================================================
   ARCHIVE — cookie consent copy
   Shortens the wording in Shopify's consent banner. Nothing else.

   Shopify still owns the banner, the buttons and every consent
   decision. This only rewrites one sentence once the banner
   appears. If it fails for any reason, Shopify's original text
   shows and consent keeps working normally.
   ============================================================ */
(function () {
  'use strict';

  var SHORT = 'We use cookies. ';
  var LINK_ID = 'shopify-pc__banner__body-policy-link';
  var done = false;

  function shorten() {
    if (done) return true;
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;

    var p = banner.querySelector('.shopify-pc__banner__body p');
    var link = document.getElementById(LINK_ID);
    if (!p || !link) return false;

    // Already shortened (Shopify can re-render the banner).
    if (p.firstChild && p.firstChild.nodeType === 3 &&
        p.firstChild.nodeValue.trim() === SHORT.trim()) {
      return true;
    }

    // Keep the real policy link node — never rebuild it, so its
    // href, target and rel stay exactly as Shopify set them.
    link.textContent = 'Privacy Policy';
    p.textContent = '';
    p.appendChild(document.createTextNode(SHORT));
    p.appendChild(link);

    done = true;
    return true;
  }

  if (shorten()) return;

  // Shopify injects the banner after page load, so watch for it.
  var observer = new MutationObserver(function () {
    if (shorten()) observer.disconnect();
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    // Stop watching after 15s so we never observe the DOM forever.
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
